import { isProductionEnv } from './env';
import type { PlatformFeatureFlagId } from '../core/models/PlatformConfig';

/**
 * Whether this build/host may default the Dev panel flag ON.
 * Production builds stay off by default; God can still enable the flag in config.
 */
export function canHostDevPanel(): boolean {
  if (import.meta.env.PROD) return false;
  if (isProductionEnv()) return false;
  return true;
}

/**
 * Default for platform flag `dev_panel`: on in development/stage/local, off in production.
 */
export function defaultDevPanelFlag(): boolean {
  return canHostDevPanel();
}

/** Menu + sheet gate: platform flag on (God-only UI already wraps the entry). */
export function isDevPanelEnabled(
  featureFlags: Partial<Record<PlatformFeatureFlagId, boolean>> | undefined,
): boolean {
  return featureFlags?.dev_panel === true;
}
